// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_hXB","cls2":"shared-cls2_ghs shared-cls1_hXB","tinted":"shared-tinted__wi","flush":"shared-flush_29p"};